import Link from 'next/link';
import { generateButtonClassNames } from 'ui';
import { LinkModuleLink } from '~/app/api/link-modules/route';

export default function TrendingSearches({
  links,
}: {
  links: LinkModuleLink[];
}) {
  return (
    <section className="container">
      <div className="mb-2 flex items-center gap-4">
        <h3 className="text-lg font-bold">Trending Searches</h3>
      </div>

      <div className="flex flex-wrap gap-2">
        {links.map(link => (
          <Link
            key={link.name}
            href={link.url}
            className={generateButtonClassNames({
              variant: 'outlined',
              className: 'whitespace-nowrap',
            })}
          >
            {link.name}
          </Link>
        ))}
      </div>
    </section>
  );
}
